"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var LoadersCssComponent = (function () {
    function LoadersCssComponent() {
        this.nodes = [];
        this._loaders = {
            "ball-pulse": 3,
            "ball-grid-pulse": 9,
            "ball-clip-rotate": 1,
            "ball-clip-rotate-pulse": 2,
            "square-spin": 1,
            "ball-clip-rotate-multiple": 2,
            "ball-pulse-rise": 5,
            "ball-rotate": 1,
            "cube-transition": 2,
            "ball-zig-zag": 2,
            "ball-zig-zag-deflect": 2,
            "ball-triangle-path": 3,
            "ball-scale": 1,
            "line-scale": 5,
            "line-scale-party": 4,
            "ball-scale-multiple": 3,
            "ball-pulse-sync": 3,
            "ball-beat": 3,
            "line-scale-pulse-out": 5,
            "line-scale-pulse-out-rapid": 5,
            "ball-scale-ripple": 1,
            "ball-scale-ripple-multiple": 3,
            "ball-spin-fade-loader": 8,
            "line-spin-fade-loader": 8,
            "triangle-skew-spin": 1,
            "pacman": 5,
            "ball-grid-beat": 9,
            "semi-circle-spin": 1
        };
    }
    LoadersCssComponent.prototype.ngOnInit = function () {
        for (var i = 0; i < this._loaders[this.loader]; i++) {
            this.nodes.push(i);
        }
    };
    return LoadersCssComponent;
}());
LoadersCssComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'loaders-css',
                template: "\n        <div class=\"loader\">\n            <div class=\"loader-inner {{loader}}\">\n                <div *ngFor=\"let node of nodes\" class=\"{{loaderClass}}\"></div>\n            </div>\n        </div>\n    "
            },] },
];
/** @nocollapse */
LoadersCssComponent.ctorParameters = function () { return []; };
LoadersCssComponent.propDecorators = {
    'loader': [{ type: core_1.Input },],
    'loaderClass': [{ type: core_1.Input },],
};
exports.LoadersCssComponent = LoadersCssComponent;
//# sourceMappingURL=loaders-css.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-loaders-css/module/loaders-css.component.js
// module id = 926
// module chunks = 7